import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { darken } from 'polished';
import DatePicker from 'react-datepicker';

export const Container = styled.div`
  padding: 20px;
  color: #e9ecef;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }

  h4 {
    color: #e9ecef;
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
  }
`;

export const Menus = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
`;

export const NewButton = styled(Link)`
  background: #626ed4;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  padding: 10px;
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s;
  margin-left: 5px;

  &:hover {
    background: ${darken(0.04, '#626ed4')};
  }

  svg {
    margin-right: 5px;
  }
`;

export const Filtro = styled.div`
  margin-right: 10px;
  display: flex;
  align-items: center;
`;

export const Button = styled.button`
  background: #626ed4;
  height: 40px;
  width: ${props => (props.reset ? '80px' : '60px')};
  border: 0;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;

  &:hover {
    background: ${darken(0.04, '#626ed4')};
  }

  margin-right: ${props => props.reset && '10px'};
`;

export const DS = styled(DatePicker)`
  width: 150px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 4px;
  color: #dee2e6;
  background: #323a4e;
  padding: 10px 5px;
  margin: 20px 5px;
`;
